import vv_utils from './vv_utils';
import { simpleInvokeMachine} from "./vv_api";

/*-----------------------------------------------
|   Application Details
-----------------------------------------------*/

/* eslint-disable max-len*/

const consentDetailsInit_onStart = () => {
  const { interpret } = window.XState;

  const tenant = window.vv_tenant_data;
  const alertbox = document.getElementById('split-alert');

  const messageMap = {
    'email' : 'Access your email address',
    'profile' : 'View your basic profile',
    'oidc' : 'Allow logins for this account',
  }

  const ignoreMap = [
    "iss",
  ]

  const profileTerms = [
    "sub",
    "name",
    "given_name",
    "family_name",
    "middle_name",
    "nickname",
    "preferred_username",
    "profile",
    "picture",
    "website",
    "email",
    "email_verified",
    "gender",
    "birthdate",
    "zoneinfo",
    "locale",
    "phone_number",
    "phone_number_verified",
    "address",
    "updated_at",
  ]

  function logAccept(context, event) {
    const userstate = event;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/consent`, userstate, 'POST');
  }

  const logAcceptMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions : {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error , alertbox);
        },
        actionSucceeded: (context, event)=> {
          
          let jsonResponse = context.data;
          window.location.assign(jsonResponse.redirect);
          logAcceptMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) =>  {return logAccept(context, event)}
      }
    })
  )
  .onTransition((state)=> {})
  .start();

  function cancel(){
    let userstate = { 'consent': false };
    logAcceptMachine.send("FETCH", userstate);
  }

  function allow(){
    let userstate = { 'consent': true };
    logAcceptMachine.send("FETCH", userstate);
  }

  document.getElementById('cancel').addEventListener("click", cancel);
  document.getElementById('allow').addEventListener("click", allow);


  let removedTerms = []
  function includesThenPop(element) {
    if (profileTerms.includes(element)) {
      removedTerms.push(element);
      return true;
    } else {
      return false;
    }
  }

  function addToolTip(element, terms) {
    element.setAttribute("data-bs-toggle", "tooltip");
    element.setAttribute("data-bs-placement", "left");
    let text = "Profile data is limited to your: " + terms.join(", ");
    element.setAttribute("title", text);
    element.querySelector("span").classList.add("text-info");
  }

  if (window.vv_tenant_data.company_name) {
    const requestBy = document.getElementById("requestBy")
    requestBy.innerText = requestBy.innerText + " " + window.vv_tenant_data.company_name
    requestBy.classList.remove("d-none")
  }

  const display = document.getElementById("display");
  const metaEl = document.getElementById("vvjson");
  let metacode = ['oidc', 'profile', "email", 'iss'];
  if (metaEl && metaEl.dataset && metaEl.dataset.vvjson ) {
    try {
      metacode = JSON.parse(atob(metaEl.dataset.vvjson)).claims;
      
      
    } catch (error) {
      // do nothing, use default, no op
      Function.prototype();
    } finally {
      //eslint issue, do a no op to make happy
      Function.prototype();
    }
  }



  let output = document.getElementById('display');
  let template = document.getElementById('displayTemplate');

  //filter the ignoremaps out of the metacodes
  metacode = metacode.filter(el => !ignoreMap.includes(el));

  //filter the profileTerms out of the metacodes
  metacode = metacode.filter(el => !includesThenPop(el));

  //if there are removedTerms, add the 'profile' to the claims if it is not there
  if (removedTerms.length > 0 && !metacode.includes('profile')) {
    metacode.push('profile')
  }

  metacode.forEach(element => {
    let clone = template.content.cloneNode(true);
    let span = clone.querySelector("span.replaceText");
    span.innerText = messageMap[element] ? messageMap[element] : "Access " + element;
    //add a tooltip if it is the profile element
    if (element === 'profile') {
      addToolTip(clone.firstChild.nextSibling, removedTerms);
    }
    output.appendChild(clone);
  })

  let tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  let tooltipList = tooltipTriggerList.forEach(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl))

}


export default {consentDetailsInit_onStart};
